<form [formGroup]="searchForm">
    <mat-form-field class="form-item search-term without-error">
        <fa-icon matPrefix class="mat-accent search-icon" [icon]="faMagnifyingGlass"></fa-icon>
        <input matInput tabindex="1" placeholder="Terme à rechercher" formControlName="searchControl" autocomplete="off" />
    </mat-form-field>
    <div class="buttons">
        <button mat-stroked-button class="primary-button button-launch-search" tabindex="4" (click)="onSearch()">Lancer la recherche</button>
        <button mat-fab class="primary-button button-filter" aria-label="Réinitialiser" matTooltip="Réinitialiser" matTooltipPosition="below" (click)="onUndo()">
            <fa-icon [icon]="resetFilterIcon"></fa-icon>
        </button>
        <button mat-fab class="primary-button button-filter" aria-label="Filtrer..." matTooltip="Filtrer..." matTooltipPosition="below" [matMenuTriggerFor]="filterMenu">
            <fa-icon [icon]="filterIcon"></fa-icon>
        </button>
    </div>
    <mat-menu #filterMenu="matMenu" class="folders-filter-menu">
        <div class="filter-menu">
            @if (filteredAttributesList.length > 0) {
                <div>
                    <p class="menu-title">Retirer un attribut du filtre</p>
                    @for (attributefiltered of filteredAttributesList; track attributefiltered.id) {
                        <div class="menu-item">
                            <mat-checkbox class="primary-button" checked="true" (change)="onRemoveAttributeFromFilter(attributefiltered)">
                                {{ attributefiltered.header }}
                            </mat-checkbox>
                        </div>
                    }
                </div>
            }
            @if (availableAttributesList.length > 0) {
                <div>
                    <p class="menu-title">Ajouter un attribut à filtrer</p>
                    @for (attribute of availableAttributesList; track attribute.id) {
                        <div class="menu-item">
                            <mat-checkbox class="primary-button" (change)="onAddAttributeToFilter(attribute)">{{ attribute.header }}</mat-checkbox>
                        </div>
                    }
                </div>
            }
        </div>
    </mat-menu>
    @for (filter of filteredAttributesList; track filter.id) {
        <mat-chip-listbox>
            <button #filterChip class="attribute-filter-button" [matMenuTriggerFor]="chipMenu">
                <mat-chip-option
                    (removed)="onRemoveAttributeFromFilter(filter)"
                    [matTooltip]="
                        !isColorInput(filter)
                            ? isDateInput(filter)
                                ? (currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDate)
                                : isDateAndTimeInput(filter)
                                  ? (currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDateAndTime)
                                  : (filter | avmAttributeFilterSubstring: currentFilterHandler.filtersForm.get(filter.propertyCode)?.value : 150)
                            : (currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmColor)
                    ">
                    @if (isColorInput(filter)) {
                        <span>{{ filter.header }}: {{ currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmColor }}</span>
                    } @else if (isDateInput(filter)) {
                        <span>{{ filter.header }}: {{ currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDate }}</span>
                    } @else if (isDateAndTimeInput(filter)) {
                        <span>{{ filter.header }}: {{ currentFilterHandler.filtersForm.get(filter.propertyCode)?.value | AvmDateAndTime }}</span>
                    } @else {
                        <span>{{ filter.header }}: {{ filter | avmAttributeFilterSubstring: currentFilterHandler.filtersForm.get(filter.propertyCode)?.value : 30 }}</span>
                    }
                    <mat-icon>expand_more</mat-icon>
                    <mat-menu style="visibility: hidden" class="attribute-filter-menu" #chipMenu="matMenu">
                        <form [formGroup]="currentFilterHandler.filtersForm" novalidate>
                            <div (click)="$event.stopPropagation()">
                                @if (!isListInput(filter) && !isColorInput(filter)) {
                                    <mat-form-field
                                        class="mat-form-field-filter without-error"
                                        [ngClass]="{
                                            'active-filter': !!currentFilterHandler.filterValues[filter.propertyCode],
                                            'mat-form-field-date-filter': isDateInput(filter),
                                        }">
                                        <div class="mat-form-field-date-filter-container">
                                            @if (isStandardInput(filter)) {
                                                <input
                                                    matInput
                                                    [formControlName]="filter.propertyCode"
                                                    [placeholder]="filter.header"
                                                    class="text-filter-input"
                                                    autocomplete="off"
                                                    (click)="$event.stopPropagation()" />
                                            } @else if (isDateInput(filter)) {
                                                <input
                                                    matInput
                                                    tabindex="3"
                                                    [matDatepicker]="i"
                                                    [formControlName]="filter.propertyCode"
                                                    [placeholder]="filter.header"
                                                    class="date-filter-input"
                                                    autocomplete="off" />
                                                @if (isDateInput(filter)) {
                                                    <mat-datepicker-toggle matSuffix [for]="i" [hidden]="!isDateInput(filter)"></mat-datepicker-toggle>
                                                }
                                                <mat-datepicker #i [hidden]="!isDateInput(filter)"></mat-datepicker>
                                            } @else if (isDateAndTimeInput(filter)) {
                                                <input
                                                    matInput
                                                    tabindex="3"
                                                    [ngxMatDatetimePicker]="j"
                                                    [formControlName]="filter.propertyCode"
                                                    [placeholder]="filter.header"
                                                    class="date-filter-input"
                                                    autocomplete="off" />
                                                @if (isDateAndTimeInput(filter)) {
                                                    <mat-datepicker-toggle matSuffix [for]="j" [hidden]="!isDateAndTimeInput(filter)"></mat-datepicker-toggle>
                                                }
                                                <ngx-mat-datetime-picker #j [hidden]="!isDateAndTimeInput(filter)"></ngx-mat-datetime-picker>
                                            } @else if (isAutocompletionByApiInput(filter)) {
                                                <input
                                                    matInput
                                                    [formControlName]="filter.propertyCode"
                                                    [placeholder]="filter.header"
                                                    class="text-filter-input"
                                                    autocomplete="off"
                                                    (click)="$event.stopPropagation()" />
                                            }
                                        </div>
                                    </mat-form-field>
                                }
                                @if (isListInput(filter) && filter.propertyCode !== BOX_ID) {
                                    <mat-selection-list class="primary-button list-selection" [formControlName]="filter.propertyCode">
                                        @for (item of filter.values; track item.value) {
                                            <mat-list-option [value]="item.value" checkboxPosition="before">{{ item.text }}</mat-list-option>
                                        }
                                    </mat-selection-list>
                                }
                                @if (isColorInput(filter)) {
                                    <mat-selection-list class="primary-button list-selection list-filter-input color-mat-select" [formControlName]="filter.propertyCode">
                                        <mat-list-option [value]="Colors.None" checkboxPosition="before">Aucune</mat-list-option>
                                        <mat-list-option [value]="Colors.Green" checkboxPosition="before">
                                            <div class="color-indicator mat-option-green-color"></div>
                                        </mat-list-option>
                                        <mat-list-option [value]="Colors.Orange" checkboxPosition="before">
                                            <div class="color-indicator mat-option-orange-color"></div>
                                        </mat-list-option>
                                        <mat-list-option [value]="Colors.Red" checkboxPosition="before">
                                            <div class="color-indicator mat-option-red-color"></div>
                                        </mat-list-option>
                                        <mat-list-option [value]="Colors.Grey" checkboxPosition="before">
                                            <div class="color-indicator mat-option-grey-color"></div>
                                        </mat-list-option>
                                        <mat-list-option [value]="Colors.LightBlue" checkboxPosition="before">
                                            <div class="color-indicator mat-option-light-blue-color"></div>
                                        </mat-list-option>
                                        <mat-list-option [value]="Colors.DarkBlue" checkboxPosition="before">
                                            <div class="color-indicator mat-option-dark-blue-color"></div>
                                        </mat-list-option>
                                    </mat-selection-list>
                                }
                            </div>
                        </form>
                    </mat-menu>
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-option>
            </button>
        </mat-chip-listbox>
    }
</form>
